<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Paparan Mel" >

      
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitPukal" @success="onSuccess">
        <w-card bg-color="" class="">
            <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          No Rujukan :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.no_rujukan}} </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Nama Pembayar :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.profil_nama}} </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Amaun (RM) :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.amaun}} 
                      </div>
                </div>
            </w-flex>
            <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh Daftar :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.created_at)}} </div>
                </div> 
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh Bayar :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.tarikh_bayar)}} </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Bil Hak Milik :
                      </h5>
                      <div class="fw-normal my1 fs-1"> {{form.bil_rekod}} </div>
                </div>
            </w-flex>
             <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Status :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.terimaan_pukal_status}}</div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                      </h5>
                      <div class="fw-normal my1 fs-1">  </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                      </h5>
                      <div class="fw-normal my1 fs-1">  </div>
                </div>
            </w-flex>
            
        </w-card>
        <br>


    <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
    
        <w-tabs :items="tabs" :no-slider="false" active-class="primary">  
            <template #item-content.1> 
                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Bil.</td>
                                        <td>Nama Pemilik</td>
                                        <td>No. Hak Milik</td>
                                        <td>Amaun Perlu Dibayar (RM)</td>
                                        <td>Amaun Dibayar (RM)</td>
                                        <td>Tindakan</td>
                                    </tr>
                                </thead>
                                <tbody>
                                 <tr v-for="dt, index in form.butir">
                                    <td>{{(index+1)}}</td>
                                    <td >
                                        {{dt.pemilik}}
                                    </td>
                                    <td >
                                        {{dt.no_hm}}
                                    </td>
                                    <td align="right">
                                        {{$zutil.currency(dt.amaun_perlu_bayar)}}
                                    </td> 
                                    <td align="right">
                                        <template v-if="form.lkp_terimaan_pukal_status_id == 1"> 
                                             <!-- <w-input class="mb4" type="number" v-model="dt.amaun"  v-on:keyup="cekBakiButiran(dt)" :validators="[validators.required]"  /> -->
                                             <z-money
                                                    v-model:originalValue="dt.amaun"
                                                    required
                                                    v-on:keyup="cekBakiButiran(dt)"
                                            />
                                         </template>
                                         <template v-else>
                                             {{dt.amaun}}
                                        </template>
                                       

                                    </td>
                                    <td>
                                        <template v-if="form.lkp_terimaan_pukal_status_id == 1"> 
                                            <w-icon
                                                class="mr1"
                                                @click="padam(dt)"
                                                >fal fa-trash</w-icon
                                            >
                                            &nbsp;&nbsp;
                                        </template>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="4"><b>Jumlah</b></td>
                                    <td align="right">
                                        <!-- {{amaun_butiran}} -->
                                         {{$zutil.currency(amaun_butiran)}}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>
                    <br><br> 


                     <template v-if="form.lkp_terimaan_pukal_status_id == 2"> 
    
                        <z-page title="Cara Bayaran">
                            <w-flex justify-center align-center class="mt5">
                                <div class="w-card__content content-hardcode">
                                    <table class="table-dashboard" width="100%">
                                        <thead>
                                            <tr>
                                                <td>Cara Bayaran</td>
                                                <td>Bank</td>
                                                <td>No Cek / Bank Draf / Transaksi Bank</td>
                                                <td>Amaun (RM)</td>
                                                <!-- <td>
                                                    <w-icon class="mr1" @click="addBayar"
                                                        >fal fa-plus</w-icon
                                                    >
                                                </td> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(d, index) in cara_bayaran">
                                                <!-- <tr> -->
                                                <td>
                                                    <z-lookup
                                                        :url="
                                                            service_utiliti +
                                                            'lookup/cara_bayar'
                                                        "
                                                        :sort="false"
                                                        :cache="false"
                                                        v-model="d.lkp_cara_bayaran_id"

                                                        required
                                                        :validators="[validators.required]"
                                                    />
                                                </td>
                                                <td>

                                                    <template v-for="(c, index) in cara_bayar">
                                                    <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_bank  == 1" >
                                                        <z-lookup
                                                            :url="
                                                                service_utiliti +
                                                                'lookup/bank'
                                                            "
                                                            :sort="false"
                                                            :cache="false"
                                                            v-model="d.lkp_bank_id"
                                                            :validators="[
                                                                validators.required,
                                                            ]"
                                                        />
                                                    </template>
                                                    </template>
                                                </td>
                                                <td>
                                                    <template v-for="(c, index) in cara_bayar">
                                                    <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_dokumen  == 1" >
                                                        <w-input
                                                            class="mb4"
                                                            v-model="d.no_dokumen"
                                                            :validators="[
                                                                validators.required,
                                                            ]"
                                                            
                                                        />
                                                    </template>
                                                    </template>
                                                </td>
                                                <td align="right" >
                                                   
                                                    {{ d.amaun }}
                                                    
                                                </td>
                                              
                                            </tr>
                                            <tr>
                                                <td colspan="3" align="right">
                                                    Jumlah (RM)
                                                </td>
                                                <td align="right">
                                                    <b>
                                                        {{form.amaun}}
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" align="right">
                                                    Jumlah Perlu Dibayar(RM)
                                                </td>
                                                <td align="right">
                                                    <b>0.00</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" align="right">
                                                    Baki(RM)
                                                </td>
                                                <td align="right">
                                                    <b>0.00</b>
                                                </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </w-flex>
                        </z-page>
                    </template>




            </template>
            <template #item-content.2>
            <w-flex justify-center align-center>
              <div class="w-card__content content-hardcode">

                  <table class="table-dashboard" width="100%">
                      <thead>
                      <tr>
                          <td >No</td>
                          <td >Tindakan</td>
                          <td >Pengguna</td>
                          <td >Tarikh</td>
                          <td>Catatan</td>
                      </tr>
                      </thead>
                      <tbody>
                      
                          <tr v-for="dt, index in form.jejak_audit">
                              <td class="w-table__cell text-left">
                                  {{(index + 1)}}
                              </td>
                              <td class="w-table__cell text-left">
                                  {{dt.tindakan_pukal.keterangan}}
                              </td>
                              <td class="w-table__cell text-left">
                                  {{dt.user.name}}
                              </td>
                              <td class="w-table__cell text-left">
                               {{$zutil.dateformat(dt.created_at)}} 
                              </td>
                              <td class="w-table__cell text-left">
                                  {{dt.catatan}}
                              </td>
                          </tr>
                          <tr v-if="form.jejak_audit.length == 0">
                              <td class="w-table__cell text-left" colspan="5">
                              </td>
                          </tr>
                      </tbody>
                      
                  </table>
                </div>
              </w-flex>
          </template>
        </w-tabs>

       
        <!-- <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitPukal" @success="onSuccess"> -->

       
             <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
               <!--  <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                    <w-icon dark tile class="mr2">fal fa-save</w-icon> Kemaskini
                </w-button> -->

                <template v-if="form.lkp_terimaan_pukal_status_id == 1"> 
                    <w-button class="my1" bg-color="success" dark  @click="send(2)" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Hantar
                    </w-button>
                </template> 
                <template v-else-if="form.lkp_terimaan_pukal_status_id == 2">
                    <!-- <template v-if="kaunter.lkp_kaunter_status_id == 1">   -->
                        <w-button class="my1" bg-color="success" dark  @click="send(3)" >
                             <w-icon dark tile class="mr2">fal fa-times</w-icon> Bayar
                        </w-button>
                    <!-- </template> -->
                </template>
                <template v-else> 

                </template>
               
            </w-flex>

        </w-form>

           

  
    </z-page>

      
  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
    resourceurl: this.service_kutipan +'terimaan_pukal',
    reload: true, 
    loading: true, 
    form:{
            butiran: [],
        },
    kaunter:{},
    hm_cukai: [],
    // butiran: [],
    error_termilan : null,
    // form_cari : [],

    form_cari: {},
    form_carian: {},
    amaun_bayaran: 0,
    amaun_butiran: 0,
    cukai: [],
    butir: [],
    draf_akaun: [],
    draf_inbois: [],
    amaun_jumlah_cukai: 0,
    form_profil: {},
    form_cari: {},
    carian_profil: { q: "" },
    profils: [],
    cara_bayaran : [
            {
                lkp_cara_bayaran_id: null,
                lkp_bank_id: null,
                no_dokumen: null,
                amaun: null,
            },
        ],
    bank : [],
    amaun_bayaran: 0,
    dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
            },

    tabs: [
          { title: 'Senarai', content: '' },
          { title: 'Jejak Audit', content: '' },
    ],

        
    
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/kutipan/mel' },
        { label: 'Mel', route: '/kutipan/mel' },
        { label: 'Papar', route: '/kutipan/mel'+this.id },
      ],
      
    }
  },
    methods: {
        caraBayar() {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/cara_bayar",
                        {}
                    )
                    .then((res) => {
                        
                        this.cara_bayar = res
                       
                    });

        },

    getData()  {
          var app = this;

          if(this.id){
            if(this.id > 0){
              this.$zcomm.get(this.service_kutipan +'terimaan_pukal/'+this.id+''+window.location.search).then(res => {
                this.form = res;
                this.cekAmaunButiran();
                this.AmaunButiran();

              });
            }
          }
          
          
        },

    send(status){

     // alert(status);
      this.form.lkp_terimaan_pukal_status_id = status
      this.form.cara_bayaran = this.cara_bayaran

        if (status == 2){
            this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                    this.getData();
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }
                        // this.$inertia.visit(this.$route('kutipan.mel.index'))

                      this.$inertia.visit(this.$route('kutipan.mel', res.id))

                            
                  })
                 
                  .catch(err => {

                  })
                  .finally(() => {
                      // this.$inertia.visit(this.$route('kutipan.mel.index'))
                      

                  });
        }else{
             this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }


                      this.$zutil.notify("Rekod telah berjaya dihantar");
                      
                            // this.$inertia.visit(this.$route("kutipan.resit.index")+"?resit_id="+res);
                            this.$inertia.visit(this.$route("kutipan.resit.index") +"?resit_id=" +res);
                            
                  })
                 
                  .catch(err => {

                  })
                  .finally(() => {
                      // this.$inertia.visit(this.$route('kutipan.mel.index'))
                      

                  });

        }


    
    },

   
   // submitPukal(){
   //   // alert('asssd');
   //      if (this.form.id > 0) {
   //            this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
   //                .then(res => {
                      

   //                  if (typeof this.onAfterEdit === "function") {
   //                      this.onAfterEdit()
   //                    }
   //                })
   //                .catch(err => {

   //                })
   //                .finally(() => {
                      

   //                });
   //        }
   //  },

  totalKenaBayar(){
           this.cara_bayaran[0].amaun = this.form.amaun
        },

    cekAmaunButiran() {
            this.amaun = 0;
            for (var i in this.cara_bayaran) {
                this.amaun =
                    this.form.amaun;
            }
            this.totalKenaBayar();
        },

    cekBakiButiran(dt) {
            dt.baki = dt.amaun;

            this.AmaunButiran();
        },

    AmaunButiran() {
                // alert('this.amaun_butira');
            this.amaun_butiran = 0;
            for (var i in this.form.butiran) {
                this.amaun_butiran =
                    this.amaun_butiran +
                    parseFloat(this.form.butiran[i].amaun);
            }
        },

     bukaKaunter() {
                this.$zcomm
                    .post(
                        this.service_kutipan + "bukakaunter",
                        {}
                    )
                    .then((res) => {
                        // if (res.ind_buka != 1) {
                            this.kaunter = res.kaunter;
                        // }
                    });

        },

    load()  {
          var app = this;
          if(this.id){
            if(this.id > 0){
              this.$zcomm.get(this.service_kutipan +'terimaan_pukal/'+this.id+''+window.location.search).then(res => {
                // this.form = res;
              })
              .finally(() => {

                this.loading = false
              });
            }
          }
    },

    padam(dt){
            var yakin = confirm("Apakah Anda Yakin?");

            if (yakin) {
                var param = {
                  id : dt.id,
                  terimaan_pukal_id : this.form.id,
                }
                this.$zcomm
                    .post(this.resourceurl + '/padam/'+this.form.id, param)
                    .then(res => {
                        this.$inertia.visit(this.route('kutipan.mel.show', this.form.id));
                    })
                    .finally(() => {
                      this.$zutil.message('Berjaya Di Padam!', false)
                      this.getData();
                    });
            } else {
                this.$zutil.notify('Batal Di Padam!', false);
            }
        },
    
 
  },
  watch: {

  },
  mounted() {
    this.load();

    if(this.id == 0){
      }

    this.getData();
    this.bukaKaunter();

    this.caraBayar();
    this.cara_bayaran = [
        {
            lkp_cara_bayaran_id: null,
            lkp_bank_id: null,
            no_dokumen: null,
            amaun: null,
        },

    ];

      
  },
    
}
</script>